import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import React, { useContext } from 'react';
import cls from 'clsx';
import Popup from '../popup';
import ConfigProviderContext from '../config-provider/ConfigProviderContext';

var Notify = function Notify(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useContext = useContext(ConfigProviderContext),
      prefixCls = _useContext.prefixCls,
      createNamespace = _useContext.createNamespace;

  var _createNamespace = createNamespace('notify', prefixCls),
      _createNamespace2 = _slicedToArray(_createNamespace, 1),
      bem = _createNamespace2[0];

  var style = {
    color: props.color,
    background: props.background
  };
  return /*#__PURE__*/React.createElement(Popup, {
    visible: props.visible,
    style: style,
    overlay: false,
    position: "top",
    lockScroll: props.lockScroll,
    onClick: props.onClick,
    onClose: props.onClose,
    onClosed: props.onClosed,
    teleport: props.teleport
  }, /*#__PURE__*/React.createElement("div", {
    className: cls(bem([props.type]), props.className)
  }, children || props.message));
};

Notify.defaultProps = {
  type: 'danger',
  duration: 3000,
  color: 'white',
  lockScroll: false
};
export default Notify;